import {createContext} from 'react';

const ControlsContextMobile = createContext();

export default ControlsContextMobile;
